





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Category from '../../models/category'
import Exam from '../../models/exam'

@Component({
  name: 'ExamListCategory'
})
export default class ExamListCategory extends Vue {
  @Prop({ required: true }) category: Category
  @Prop({ default: 0 }) padding: number
  @Prop({ default: true }) isCategoryRoot: boolean
  @Prop({ default: false }) showEmpty: boolean
  @Prop({ default: () => [] }) exams: Exam[]

  get categoryExams(): Exam[] {
    return this.category.getExams(this.exams)
  }

  clickCategory(category) {
    this.$emit('clickCategory', category)
  }
  
  get categoryHasExam() {
    return this.category.children.filter((x) => x.examsCount > 0)
  }
}
